import { computed, ref, watch } from "@vue/composition-api";

/**
 * Crud edit composition for crud dialogs
 * @param {editedItem, value} props
 * @param {setupContext} ctx
 * @param {defaultCrud} defaultCrud
 * @param {posterFunction} poster
 * @returns crud Edit composition
 */
export const crudEditComposition = (props, ctx, defaultCrud, poster) => {
  const isEdition = computed(() => {
    !!props.editedItem?.uuid;
  });

  const form = ref(null);

  const loading = ref(false);

  const crud = ref(JSON.parse(JSON.stringify(defaultCrud)));

  const onSuccess = async () => {
    if (!form.value?.validate()) return;
    try {
      loading.value = true;
      const response = await poster(crud.value);
      ctx.emit("new-item", response.data);
      ctx.emit("input", false);
    } finally {
      loading.value = false;
    }
  };

  const onReject = () => {
    ctx.emit("input", false);
  };

  function updateCrud() {
    crud.value = JSON.parse(JSON.stringify(props.editedItem || defaultCrud));
    form.value?.resetValidation();
  }

  watch(() => props.editedItem, updateCrud);

  watch(
    () => props.value,
    (value) => {
      if (value) updateCrud();
    },
  );

  return {
    crud,
    form,
    isEdition,
    loading,
    onSuccess,
    onReject,
  };
};
